import { render, staticRenderFns } from "./changeOrders.vue?vue&type=template&id=06e3c762&scoped=true&"
import script from "./changeOrders.vue?vue&type=script&lang=js&"
export * from "./changeOrders.vue?vue&type=script&lang=js&"
import style0 from "./changeOrders.vue?vue&type=style&index=0&id=06e3c762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3c762",
  null
  
)

export default component.exports